// Favourite app tab (App/Code/Design) — per device, localStorage.
// When set, the desktop app boots straight into that tab.
const FAVOURITE_APP_KEY = "tf_favourite_app";
// The browser "storage" event only fires in OTHER windows, so a same-window
// event is dispatched to keep every listener in sync on the same click.
const FAVOURITE_APP_EVENT = "tf_favourite_app_changed";

const FAVOURITE_APP_TABS = ["app", "code", "design"];

export const readFavouriteApp = () => {
  try {
    const value = localStorage.getItem(FAVOURITE_APP_KEY);
    return FAVOURITE_APP_TABS.includes(value) ? value : null;
  } catch (_) {
    return null;
  }
};

export const writeFavouriteApp = (tab) => {
  try {
    if (tab && FAVOURITE_APP_TABS.includes(tab)) {
      localStorage.setItem(FAVOURITE_APP_KEY, tab);
    } else {
      localStorage.removeItem(FAVOURITE_APP_KEY);
    }
  } catch (_) {}
  try {
    window.dispatchEvent(new Event(FAVOURITE_APP_EVENT));
  } catch (_) {}
};

export const subscribeFavouriteApp = (callback) => {
  const sync = () => callback(readFavouriteApp());
  window.addEventListener("storage", sync);
  window.addEventListener(FAVOURITE_APP_EVENT, sync);
  return () => {
    window.removeEventListener("storage", sync);
    window.removeEventListener(FAVOURITE_APP_EVENT, sync);
  };
};
